import { useState } from "react";
import { Play } from "lucide-react";
import { VideoModal } from "@/components/site/VideoModal";
import { LeadForm } from "@/components/site/LeadForm";

export const Section = ({ id, className = "bg-ivory", children }) => (
  <section id={id} className={`${className} py-20 md:py-28 scroll-mt-24`}>
    <div className="container-lr">{children}</div>
  </section>
);

export const Eyebrow = ({ children, light }) => (
  <div className="flex items-center gap-4">
    <span className="gold-rule" />
    <p className={`eyebrow ${light ? "text-gold" : ""}`}>{children}</p>
  </div>
);

export const Heading = ({ children, light }) => (
  <h2 className={`mt-6 font-serif font-semibold tracking-display text-3xl md:text-4xl lg:text-5xl leading-[1.08] ${light ? "text-ivory" : "text-legacy"}`}>
    {children}
  </h2>
);

export const Note = ({ children, light }) => (
  <div className={`mt-6 rounded-card border p-5 text-[0.85rem] leading-relaxed ${light ? "border-ivory/20 bg-white/5 text-taupe" : "border-taupe/50 bg-[#EFE8D9] text-slate"}`}>
    {children}
  </div>
);

export const GatedForm = ({ list, note, source = "resources", submitLabel, showDisclosure }) => (
  <LeadForm list={list} source={source} note={note} submitLabel={submitLabel} showDisclosure={showDisclosure} />
);

// Lazy video facade that opens the shared accessible VideoModal.
export const VideoBlock = ({ id, title, description, className = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`video-facade-${id}`}
        className="group relative block w-full aspect-video rounded-card overflow-hidden border border-taupe/40 bg-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold"
      >
        <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt={title} loading="lazy" className="h-full w-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-gold text-legacy group-hover:scale-105 transition-transform">
            <Play size={26} className="ml-0.5" fill="currentColor" />
          </span>
        </span>
      </button>
      {title && <p className="mt-3 text-sm text-slate font-medium">{title}</p>}
      <VideoModal open={open} onClose={() => setOpen(false)} videoId={id} title={title} description={description} />
    </div>
  );
};
